// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `Avatar`.
export const Avatar = __t.enum("Avatar", {
  Alice: __t.unit(),
  Bob: __t.unit(),
  Charlie: __t.unit(),
  Diana: __t.unit(),
  Eve: __t.unit(),
  Frank: __t.unit(),
  Grace: __t.unit(),
  Henry: __t.unit(),
  Ivy: __t.unit(),
  Jack: __t.unit(),
  Karen: __t.unit(),
  Leo: __t.unit(),
  Maria: __t.unit(),
  Nora: __t.unit(),
  Oscar: __t.unit(),
  Paul: __t.unit(),
  Quinn: __t.unit(),
  Ruby: __t.unit(),
  Steve: __t.unit(),
  Tina: __t.unit(),
  FromName: __t.unit(),
  FromIdentity: __t.unit(),
});
export type Avatar = __Infer<typeof Avatar>;

export const DeckCard = __t.object("DeckCard", {
  id: __t.u64(),
  symbol: __t.string(),
});
export type DeckCard = __Infer<typeof DeckCard>;

export const DeleteRoom = __t.object("DeleteRoom", {
  roomId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type DeleteRoom = __Infer<typeof DeleteRoom>;

export const Feedback = __t.object("Feedback", {
  id: __t.u64(),
  submitterIdentity: __t.identity(),
  text: __t.string(),
  timestamp: __t.timestamp(),
});
export type Feedback = __Infer<typeof Feedback>;

export const OngoingVote = __t.object("OngoingVote", {
  participantId: __t.u64(),
  chosenCardId: __t.u64(),
});
export type OngoingVote = __Infer<typeof OngoingVote>;

export const Participant = __t.object("Participant", {
  id: __t.u64(),
  identity: __t.identity(),
  roomId: __t.u64(),
  name: __t.string(),
  get avatar() {
    return Avatar;
  },
  get role() {
    return ParticipantRole;
  },
});
export type Participant = __Infer<typeof Participant>;

// The tagged union or sum type for the algebraic type `ParticipantRole`.
export const ParticipantRole = __t.enum("ParticipantRole", {
  Moderator: __t.unit(),
  Player: __t.unit(),
  Spectator: __t.unit(),
});
export type ParticipantRole = __Infer<typeof ParticipantRole>;

export const ParticipantView = __t.object("ParticipantView", {
  get profile() {
    return Profile;
  },
  get role() {
    return ParticipantRole;
  },
  get voteState() {
    return VoteStateView;
  },
});
export type ParticipantView = __Infer<typeof ParticipantView>;

export const Participation = __t.object("Participation", {
  connectionId: __t.connectionId(),
  participantId: __t.u64(),
});
export type Participation = __Infer<typeof Participation>;

export const Profile = __t.object("Profile", {
  identity: __t.identity(),
  name: __t.string(),
  get avatar() {
    return Avatar;
  },
});
export type Profile = __Infer<typeof Profile>;

export const RevealedVoteRecordView = __t.object("RevealedVoteRecordView", {
  get profile() {
    return Profile;
  },
  chosenCardId: __t.u64(),
  chosenCardSymbol: __t.string(),
});
export type RevealedVoteRecordView = __Infer<typeof RevealedVoteRecordView>;

export const Room = __t.object("Room", {
  id: __t.u64(),
  code: __t.string(),
  permanent: __t.bool(),
  currentTopic: __t.string(),
  revealed: __t.bool(),
  get currentDeck() {
    return __t.array(DeckCard);
  },
});
export type Room = __Infer<typeof Room>;

export const RoomRevealOutcome = __t.object("RoomRevealOutcome", {
  id: __t.u64(),
  roomId: __t.u64(),
  timestamp: __t.timestamp(),
  topic: __t.string(),
  get votes() {
    return __t.array(RoomRevealVote);
  },
});
export type RoomRevealOutcome = __Infer<typeof RoomRevealOutcome>;

export const RoomRevealVote = __t.object("RoomRevealVote", {
  participantId: __t.u64(),
  chosenCardId: __t.u64(),
  chosenCardSymbol: __t.string(),
});
export type RoomRevealVote = __Infer<typeof RoomRevealVote>;

export const RoomView = __t.object("RoomView", {
  code: __t.string(),
  permanent: __t.bool(),
  currentTopic: __t.string(),
  revealed: __t.bool(),
  get currentDeck() {
    return __t.array(DeckCard);
  },
  get participants() {
    return __t.array(ParticipantView);
  },
  get voteHistory() {
    return __t.array(VoteResultRecordView);
  },
  myConnections: __t.array(__t.connectionId()),
});
export type RoomView = __Infer<typeof RoomView>;

export const VoteResultRecordView = __t.object("VoteResultRecordView", {
  timestamp: __t.timestamp(),
  topic: __t.string(),
  get votes() {
    return __t.array(RevealedVoteRecordView);
  },
});
export type VoteResultRecordView = __Infer<typeof VoteResultRecordView>;

// The tagged union or sum type for the algebraic type `VoteStateView`.
export const VoteStateView = __t.enum("VoteStateView", {
  NotVoted: __t.unit(),
  Voted: __t.unit(),
  get Revealed() {
    return DeckCard;
  },
});
export type VoteStateView = __Infer<typeof VoteStateView>;

